// Define a query key factory for canvases
export const canvasKeys = {
  all: ["canvases"] as const,
  detail: (externalId: string, language?: string, isParticipation?: boolean) => {
    // Use a specific segment like 'initial_fetch' if language is undefined
    const langSegment = language || "initial_fetch";
    return [...canvasKeys.all, "detail", externalId, langSegment, { isParticipation }] as const;
  },
};
